import { Component, OnInit, Input, SimpleChanges, OnChanges, ViewEncapsulation } from '@angular/core';
//import { Component, OnInit, Input, SimpleChanges, OnChanges, Output, EventEmitter } from '@angular/core';
import { ContentEntryPublishRenderDescriptor } from '../../model/ContentEntryPublishRenderDescriptor';
import { TopicLeaf } from '../../model/TopicLeaf';
//import { ContentEntryDisplayData } from '../../model/ContentEntry/ContentEntryDisplayData';
//import { DomSanitizer, SafeStyle, Title } from '@angular/platform-browser';
import { globals } from '../shared/globals';
import { Router } from '@angular/router';
import { SafeStyle, DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-display-content-entry',
  templateUrl: './display-content-entry.component.html',
  styleUrls: ['./display-content-entry.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class DisplayContentEntryComponent implements OnInit, OnChanges {
  @Input() contentEntry: ContentEntryPublishRenderDescriptor;
  @Input() selectedTopic: TopicLeaf;
  //  @Output() showContentEntry = new EventEmitter<ContentEntryDisplayData>();
  @Input() area: string;


  private justTheUrl: string;
  private imgUrl: SafeStyle;
  theID = "none";

  ngOnChanges(changes: SimpleChanges) {
    let stringVersion = JSON.stringify(changes.contentEntry.currentValue);
    let parsed = JSON.parse(stringVersion);

    if (!parsed.ThumbnailImageAssetID)
      return;
    this.justTheUrl = "/assets/databaseimages/" + parsed.ThumbnailFilename;
    this.imgUrl = this.sanitizer.bypassSecurityTrustStyle("url(" + this.justTheUrl + ")")
  }
  /*
    ShowContent()
    {
      var contentEntryData: ContentEntryDisplayData  = ContentEntryDisplayData.InstantiateOneLevelContentEntryDisplayData(this.selectedTopic, this.contentEntry);
      this.showContentEntry.emit(contentEntryData);
    }
  */
  constructor(private _router: Router, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    if (this._router.url.indexOf("videocoursesview") >= 0 || this._router.url.indexOf("shortvideosview") >= 0) {
      this.theID = "thevideocourse";
    }
  }

}
